<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <v-card>
            <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
                <v-flex xs12>
                    <v-btn fab x-small @click="$router.go(-1)">
                        <v-icon>navigate_before</v-icon>

                    </v-btn>
                </v-flex>

                <v-flex xs12 md1 class="mb-2">
                    <v-btn
                        fab
                        small
                        @click="printTable()"
                        class="ml-8 white--text"
                        color="#2b6993"
                        elevation="4"
                        absolute
                        right
                    >
                        <v-icon>print</v-icon>
                    </v-btn>
                </v-flex>

                <v-flex xs12>
                    <h3 class="text-center mb-5">Training History Report</h3>
                    <v-divider class="ml-4 mr-4 mb-3"></v-divider>
                </v-flex>

                <v-flex xs12 md6 class="pa-1">
                  <DatePicker v-model="reportFilters.startDate"/>
                </v-flex>

                <v-flex xs12 md6 class="pa-1">
                  <DatePicker v-model="reportFilters.endDate"/>
                </v-flex>

                <v-flex xs12 md4 class="mt-5 mb-5 pl-5">
                    <v-btn @click="trainingQuery()">Search</v-btn>
                </v-flex>

                <v-flex xs12 class="pa-2">
                    <v-data-table
                        :headers="headers"
                        :items="trainings"
                        sort-by="Date"
                        sort-asc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading History of Trainings"
                        :items-per-page="100"
                    >
                        <template v-slot:top>
                            <tr>
                                <td></td> <!-- Empty cell for the first column -->
                                <td></td> <!-- Empty cell for the second column -->
                                <td></td> <!-- Empty cell for the third column -->
                                <td></td> <!-- Empty cell for the fourth column -->
                                <td class="text-right pl-3">Total Training Hours:</td>
                                <td class="font-weight-bold pl-2"> {{ calculateTotalHours() }}</td>
                                <!-- Display total hours -->
                                <td></td> <!-- Empty cell for the last column -->
                            </tr>
                        </template>
                        <template v-slot:item.Signed="{ item }">
                            <v-icon
                                class="ma-2"
                                color="red"
                                small
                                v-if="!item.Signed"
                            >
                                close
                            </v-icon>
                            <v-icon
                                class="ma-2"
                                color="green"
                                small
                                v-if="item.Signed"
                            >
                                check
                            </v-icon>
                        </template>
                        <template v-slot:item.select="{ item }">

                            <v-btn
                                x-small
                                class="white--text"
                                color="#2b3990"
                                @click="viewTraining(item)"
                            >
                                View
                            </v-btn>

                        </template>
                    </v-data-table>

                    <v-dialog v-model="dialog" max-width="80%">
                        <v-card>
                            <v-card-title style="background-color: #2b3990">
                                <span class="headline white--text">{{ titleForm }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="4" v-if="isAdmin">
                                            <v-autocomplete
                                                clearable
                                                :items="users"
                                                item-text="Name"
                                                item-value="_id"
                                                label="Trainer(s)"
                                                multiple
                                                v-model="newTrainer"
                                                prepend-icon="person"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-autocomplete
                                                :items="users"
                                                item-text="Name"
                                                item-value="_id"
                                                label="Trainer(s)"
                                                multiple
                                                v-model="newTrainer"
                                                prepend-icon="person"
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-autocomplete
                                                v-model="newTrainingType"
                                                label="Training Type"
                                                :items="Trainings"
                                                item-Name="Name"
                                                :readonly="role != 'Administration'"
                                            ></v-autocomplete>
                                        </v-col>
                                        <!-- <v-col cols="12" sm="4">
                                          <v-autocomplete
                                            v-model="newTrainingSubject"
                                            label="Training Subject"
                                            :items="Subjects"
                                            item-Name="Name"
                                          ></v-autocomplete>
                                        </v-col> -->
                                        <v-col cols="12" sm="4">
                                            <v-text-field
                                                v-model="newTrainingSubject"
                                                label="Training Subject"
                                                :items="Subjects"
                                                item-Name="Name"
                                                :readonly="role != 'Administration'"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <!-- <v-menu
                                              min-width="290px"
                                              max-widht="290px"
                                            >
                                              <template v-slot:activator="{ on }">
                                                <v-text-field
                                                  :value="newDate"
                                                  label="Date of Training"
                                                  v-on="on"
                                                  prepend-icon="events"
                                                  :readonly="role != 'Administration'"

                                                ></v-text-field>
                                              </template>
                                              <v-date-picker v-model="newDate" :readonly="role != 'Administration'"></v-date-picker>
                                            </v-menu> -->
                                            <v-menu
                                                ref="menu"
                                                v-model="menu"
                                                :close-on-content-click="false"
                                                :return-value.sync="date"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="auto"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="newDate"
                                                        label="Date of Training"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="newDate"
                                                    no-title
                                                    scrollable
                                                    :readonly="role !== 'Administration'"
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="menu = false"
                                                    >
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="$refs.menu.save(date)"
                                                    >
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6">

                                            <v-select
                                                :items="times"
                                                v-model="newTimeStarted"
                                                label="Time Training Started"
                                                prepend-icon="mdi-clock-time-four-outline"

                                            ></v-select>

                                        </v-col>

                                        <v-col cols="12" sm="12" md="6">

                                            <v-select
                                                :items="times"
                                                v-model="newTimeEnded"
                                                label="Time Training Ended"
                                                prepend-icon="mdi-clock-time-four-outline"
                                                @change="calcHours()"
                                            ></v-select>

                                        </v-col>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-text-field
                                                v-model="newDuration"
                                                label="Duration"
                                                prepend-icon="schedule"
                                                :readonly="role != 'Administration'"
                                                suffix="hrs"

                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="12">
                                            <v-textarea
                                                v-model="newOutline"
                                                label="Training Outline"
                                                outlined
                                                :readonly="role != 'Administration'"
                                                auto-grow
                                            ></v-textarea>
                                        </v-col>

                                        <v-col cols="12" sm="12">
                                            <v-textarea
                                                v-model="newDescription"
                                                label="Training Description"
                                                outlined
                                                :readonly="role != 'Administration'"
                                                auto-grow
                                            ></v-textarea>
                                        </v-col>

                                        <v-col cols="12" sm="12">
                                            <v-text-field
                                                v-model="newLink"
                                                label="Training Link"
                                                outlined
                                                :readonly="role != 'Administration'"

                                            ></v-text-field>
                                        </v-col>

                                        <v-col cols="12">
                                            <v-file-input
                                                v-model="newDocument"
                                                class="pa-2"
                                                label="Select documents to upload"
                                                show-size
                                                filled
                                                multiple
                                                prepend-icon="mdi-camera"
                                                accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                @change="fileSelected"
                                                :readonly="role != 'Administration'"

                                            >
                                                <template #selection="{ text, index }">
                                                    <v-chip small label close color="primary"
                                                            @click:close="deleteChip(index)">{{ text }}
                                                    </v-chip>
                                                </template>
                                            </v-file-input>
                                        </v-col>

                                        <v-col cols="12" sm="12"
                                               v-for="doc in newDocument"
                                               :key="doc.id"
                                        >
                                            <div v-if="doc.ext !='pdf' ">
                                                <v-img
                                                    max-height="480"
                                                    max-width="550"
                                                    :src="doc.aws"
                                                ></v-img>
                                            </div>
                                            <div v-if="doc.ext =='pdf' ">
                                                <LoadPdf
                                                    :pdfFile="doc.aws"
                                                    :pdfName="doc.name"
                                                />
                                            </div>
                                        </v-col>

                                        <v-col cols="12" sm="6">
                                            <v-checkbox label="Sign for Attending Training" @click="addSignature()"
                                                        v-model="newSigned"></v-checkbox>
                                            <v-expand-transition v-if="newSigned">
                                                <v-text-field label="Signature" v-model="newSignature"
                                                              readonly></v-text-field>
                                            </v-expand-transition>
                                        </v-col>
                                        <v-col cols="12" sm="6" v-if="canSign">
                                            <div class="v-input--selection-controls__ripple primary--text">Trainer Signature</div>

                                            <v-btn color="#259647"
                                                class="white--text"
                                                @click="signAndSave()"
                                                v-if="!newTrainerSigned"
                                                >
                                                    Sign and Save
                                                </v-btn>
                                            <v-expand-transition v-if="newTrainerSigned">
                                            <v-text-field label="Signature" v-model="newTrainerSignature" readonly></v-text-field>
                                            </v-expand-transition>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    fab
                                    small
                                    @click="showPrintModal()"
                                    class="mr-8 mb-2 white--text"
                                    color="#2b6993"
                                    elevation="4"
                                >
                                    <v-icon>print</v-icon>
                                </v-btn>
                                <v-btn color="blue darken-1" text @click="close">Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-flex>
            </v-layout>
        </v-card>
    </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
// import Foot from '../components/Footer'

const url = require("../../client_config/config").url;

export default {
    mixins: [],
    components: {
      DatePicker,
    },
    data: () => ({
        headers: [
            {
                text: 'Date',
                align: 'start',
                sortable: true,
                value: 'Date',
            },
            {text: "Duration", value: "Duration"},
            {text: "Employee", value: "EmployeeID.Name"},
            {text: "Training Type", value: "TrainingType"},
            {text: "Training Subject", value: "TrainingSubject"},
            {text: "Trainers", value: "Trainers"},
            {text: "Signed", value: "Signed"},
            {text: "", value: "select"},

        ],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        employees: [],
        trainings: [],
        dialog: false,
        calendarMenu: false,
        calendar2Menu: false,
        menu: false,
        menu2: false,
        report: '',
        staff: '',
        clientName: '',
        isLoading: false,
        signed: false,
        role: localStorage.getItem('userRole'),
        state: localStorage.getItem('userState'),
        requiredField: [
            v => !!v || 'This is required',
        ],
        titleForm: "New Training",
        trainingID: "",
        token: localStorage.getItem('token'),
        newTrainer: [],
        newTrainingType: "",
        newTrainingSubject: "",
        newDate: moment(new Date()).format("YYYY-MM-DD"),
        newTimeStarted: "",
        newTimeEnded: "",
        newDuration: "",
        newOutline: "",
        newDescription: "",
        newSigned: false,
        newSignature: "",
        newLink: "",
        editedIndex: -1,
        documents: "",
        documentLink: "",
        newDocument: [],
        imageDetails: [],
        pdfDetails: [],
        notSigned: false,
        employee: {},
        uploadFile: "",
        list: [
            "Signed",
            "Needs Signature"
        ],
        text: "",
        msg: false,
        isAdmin: false,
        users: [],
        trainingSubjectsOptions: [],
        reportFilters:  {
            startDate: '',
            endDate: '',
            staffStatus: '',
            StaffID: '',
            signatureBool: '',
            trainingSubject: '',
        },
        newTrainerSigned: false,
        newTrainerSignature: "",
        userRole: localStorage.getItem('userRole')
    }),

    computed: {
    },

    created() {
        this.getEmployees();
    },

    mounted() {
    },

    beforeDestroy() {
    },

    watch: {
    },

    methods: {
        initialize() {
            this.trainings = [];
        },


        async getEmployees() {
            let endpoint = '';
            const companyIds = localStorage.getItem('userCompanies');

            endpoint = `${url}/users/state/${this.state}`;

            await axios.get(endpoint, {
                params: {
                    Company: JSON.parse(companyIds)
                }
            }).then(res => {
                this.users = res.data.users;

            });
        },

        close() {
            this.dialog = false;
        },

        trainingQuery() {
            this.trainings = []
            this.isLoading = true;

            const companyIds = localStorage.getItem('userCompanies');

            axios.get(`${url}/globalTraining/all-global-trainings`, {
              params: {
                Company: JSON.parse(companyIds),
                startDate: this.reportFilters.startDate,
                endDate: this.reportFilters.endDate,
              }
            }).then(res => {
                this.trainings = res.data.trainings.map(training => {
                    return {
                        ...training,
                        Trainers: training.Trainers.map(trainer => trainer.Name).join(', ')
                    };
                });
                this.isLoading = false;
            })

        },

        getStaffID(item) {
            this.staff = item.EmployeeID;
            window.localStorage.setItem('staffId', this.staff)
            console.log(this.staff + " is the staff")
        },

        viewTraining(item) {
            if (item.Signature == null) {
                this.newSigned = false
            } else {
                this.newSigned = true
            }
            this.titleForm = "Viewing Training";
            this.dialog = true;
            this.editTraining = true;
            this.newTraining = false;
            this.newTrainingType = item.TrainingType;
            this.newTrainingSubject = item.TrainingSubject;
            this.newDate = item.Date;
            this.newTimeStarted = item.TimeStarted;
            this.newTimeEnded = item.TimeEnded;
            this.newDuration = item.Duration;
            this.newOutline = item.Outline;
            this.newDescription = item.Description;
            this.newSigned = item.Signed;
            this.newSignature = item.Signature;
            this.newTrainer = item.Trainer;
            this.newLink = item.Link;
            this.trainingID = item._id;
            this.newTrainerSignature = item.TrainerSignature == undefined ? '':item.TrainerSignature;
            this.newTrainerSigned = this.newTrainerSignature == '' ? false : true;
            if (item.documents.length > 0) {
                const tempData = [];
                for (let i = 0; i < item.documents.length; i++) {
                    let fileExt = item.documents[i].AWSLink.split('.').pop();
                    tempData.push({
                        name: item.documents[i].Name,
                        id: item.documents[i]._id,
                        aws: item.documents[i].AWSLink,
                        ext: fileExt

                    });
                }
                this.newDocument = tempData;
            }
        },
    }
}
</script>
<style>
#print {
    display: none
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}


@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}
</style>
